const isModerator = user =>
  user && user.permissions && user.permissions.includes('comment:moderator');

export default isModerator;
